<template>
    <div class="w-100 video-item-container" :class="videoContainerClasses">
        <div class="row pb-2 d-flex" :class="videoClasses" style="height: auto;">
            <div :class="columnClass" class="d-flex flex-row justify-content-center">
                <EmbeddedVideoPlayer
                    :videoId="videoId"
                    :videoSource="videoSrc"
                    :videoThumbnail="videoThumbnail"
                    :selectedVideoId="selectedVideoPlayingId"
                    :isMP4Video="isMP4Video"
                    @video-player-in-progress="isVideoPlayerPlayer"
                />
            </div>

            <div :class="columnClass" class="d-flex flex-column mb-0 video-gap-between">
                <div class="library-item-text video-title w-100 d-flex flex-row justify-content-start mt-1">
                    {{ videoTitle }}
                </div>

                <div 
                    class="video-description mb-4"
                >
                    <span v-html="videoTextDescription"></span>
                </div>

                <div 
                    class="video-share-button" 
                    :class="{ 'share-button-from-right': !showShareButtonFromLeft, 'share-button-from-left': showShareButtonFromLeft }"
                    :id="`video-tooltip-${videoId}`" 
                    @click="toggleCopyVideoUrl"
                >
                    <img
                        class="video-share-image"
                        :src="require('../../../assets/images/Share-08.svg')"
                        width="20px"
                        height="20px"
                    />
                </div>

                <!-- VIDEO SHARE COPY TO CLIPBOARD -->
                <CopyUrlClipboard
                    v-if="isDropdownOpen && videoShare"
                    :classes="'share-button-from-left'"
                    :urlSource="videoShare"
                    :copyHandlerComplete="afterCopyHandler"
                />

                <!-- VIDEO SOURCE COPY TO CLIPBOARD -->
                <CopyUrlClipboard
                    v-else-if="isDropdownOpen"
                    :classes="showShareButtonFromLeft ? 'share-button-from-left' : 'dropdown-content-from-right'"
                    :urlSource="videoSrc"
                    :copyHandlerComplete="afterCopyHandler"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import EmbeddedVideoPlayer from './embedded-video-player.vue';
    import CopyUrlClipboard from './copy-url-clipboard';

    export default {
        name: "VideoLibraryItem",
        props: {
            videoShare: String,
            videoSrc: String,
            videoType: String,
            videoTitle: String,
            videoId: String,
            videoTextDescription: String,
            videoThumbnail: String,
            selectedVideoPlayingId: String,
            isVideoPlayerPlayer: Function,
            isMP4Video: Boolean,
            videoIdForCopyVideoSrcUrl: String,
            videoClasses: String,
            videoContainerClasses: String,
            columnClass: {
                type: String,
                default: "col-12"
            },
            showShareButtonFromLeft: {
                type: Boolean,
                default: false,
            }
        },
        data(){
            return {
                isDropdownOpen: false,
            }
        },
        components: {
            EmbeddedVideoPlayer,
            CopyUrlClipboard,
        },
        computed: {
            videoTagClass() {
                switch(this.videoType) {
                    case 'Cybersecurity':
                        return 'cyber-security-tag';
                    case 'Project Spectrum':
                        return 'project-spectrum-tag';
                    case 'Spectrum Manufacturers':
                        return 'spectrum-manufacturers-tag';
                    case 'Understanding Data':
                        return 'understanding-data-tag';
                    case 'Business Tools':
                        return 'business-tools-tag';
                    case 'CMMC':
                        return 'cmmc-tag';
                    case 'NIST 800-171':
                        return 'nist-800-171-tag';
                    default:
                        return 'general-tag';
                };
            }
        },
        methods: {
            toggleCopyVideoUrl() {
                this.isDropdownOpen = !this.isDropdownOpen;
                if(this.videoIdForCopyVideoSrcUrl !== this.videoId) {
                    this.$emit("receive-videoId-forCopyVideoUrl", this.videoId);
                }
            },
            afterCopyHandler() {
                this.isDropdownOpen = false;
                this.$emit("receive-videoId-forCopyVideoUrl", null);
            },
        },
        watch: {
            videoIdForCopyVideoSrcUrl(newValue) {
                if(newValue !== null && this.isDropdownOpen === true && newValue !== this.videoId) {
                    this.isDropdownOpen = false;
                }
            },
        }
    }
</script>

<style scoped>

    .library-item-tag {
        border-radius: 50px;
        padding: 5px 10px;
        font-size: 14px;
        font-weight: 600;
        color: #000;
        width: 200px !important;
    }
    .video-item-container {
        background-color: #D9D9D9;
        border-radius: 10px;
        padding: 15px;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        position: relative;
    }

    .library-item-text {
        color: #000;
        font-family: Rajdhani;
        font-style: normal;
        font-weight: 700;
        min-height: 50px;
    }

    .video-type {
        font-size: 16px;
        line-height: 20px;
    }

    .video-title {
        font-size: 22px;
        line-height: 24px;
    }

    .video-description > :deep span {
        color: rgba(0, 0, 0, 0.60);
        font-family: Rajdhani;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px;
        min-height: 60px;
    }

    .video-gap-between {
        gap: 0.5rem;
        position: relative;
    }

    .video-share-button {
        position: absolute;
        bottom: 10px;
        width: auto;
        height: 30px;
        display: flex;
        justify-content: center;
        cursor: pointer;
        color: #424EC4;
        font-weight: 600;
        padding-top: 7px;
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 5px;
    }

    .video-share-button:hover {
        background-color: #f1f1f1;
    }

    .video-share-image {
        filter: invert(25%) sepia(89%) saturate(1253%) hue-rotate(214deg) brightness(97%) contrast(90%);
    }

    .share-button-from-right {
        right: 1px;
    }

    .share-button-from-left {
        left: 5px;
    }

    .dropdown-content-from-right {
        right: -10px;
    }

    .dropdown-content-from-left {
        left: -10px;
    }
</style>